export class CommissionUpdate
{
    storeid: string;
    billerid: string;
    rate: string;  
}


// WEBPACK FOOTER //
// /tmp/build_713add00/src/models/commissionupdatemodel.ts